import { useTranslation } from '@framework/i18n';
import { Space, Typography, UploadFile } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const FileNameStyledSpace = styled(Space)`
  .ant-typography,
  .anticon {
    font-size: 16px;
  }
`;

const UploadedFileRowWrapper = styled.div`
  margin-top: -2px;
  padding-top: 6px;
  padding-left: 8px;
  border-left: 4px solid ${props => props.theme.colorBorderSecondary};
  padding-bottom: 2px;
  & + & {
    padding-top: 8px;
  }
`;

export interface IFileRowProps {
  file: UploadFile;
  icon: React.ReactNode;
  downloadButton?: React.ReactNode;
  deleteButton?: React.ReactNode;
  readonly?: boolean;
  extra?: React.ReactNode;
}

/**
 * Riga che contiene i dati di un file caricato. Simula la fileList dell'upload di antd.
 */
export function FileRow(props: IFileRowProps) {
  const { icon, file, downloadButton, deleteButton, readonly, extra } = props;
  const { t } = useTranslation();

  return (
    <UploadedFileRowWrapper>
      <div>
        <Space wrap size={[16, 0]}>
          <Space>
            <FileNameStyledSpace size={4} align="center">
              {icon}
              <Typography.Text
                type={file.status === 'error' ? 'danger' : undefined}
              >
                <span className="sr-only">
                  {t('file-row.file-uploaded-prefix', 'File caricato: ')}
                </span>
                {file.name}
              </Typography.Text>
            </FileNameStyledSpace>
            {file.status !== 'error' && downloadButton}

            {!readonly && deleteButton}
          </Space>
          {extra}
        </Space>
      </div>
    </UploadedFileRowWrapper>
  );
}
